export default {
  login: {
    login: 'Sign in',
    formTitle: 'Sign in to LUCKY PM system',
    userNameTip: 'Please input account name',
    passwordTip: 'Please input password',
    welcome: 'Welcome',
    register: 'Register',
    confirePassword: 'Confirm password',
    passwordAgain: 'Please input the password again',
    phoneByDingTalk: 'Phone number(DingTalk)',
    phoneFormat: 'Wrong format of mobile phone number',
    passwordInconsistent: 'Two inputs do not match!',
    registerSuccess: 'Successfully registered, please Sign in',
    smsCode: 'Verification code',
    getSmsCode: 'Get verification code',
    againGetSmsCode: 'Refetch after {countDown} seconds',
  },
  account: {
    accountInfo: 'Account Info',
    userName: 'Account',
    password: 'Password',
    avatar: 'Avatar',
    language: 'Language',
    active: 'Active',
    mobile: 'Phone number',
    DingTalkID: 'DingTalkID',
    permission: 'Permission',
    role: 'Role',
    team: 'Team',
    updatePassword: 'Update password',
    passwordNoEmpty: 'Password cannot be empty',
    loginAgain: 'Sign in again after resetting password',
    avatarUrl: 'Avatar url',
    preview: 'Preview',
    avatarUrlError: 'Avatar url error',
    updateAccount: 'Update account info',
    updateAvatar: 'Update Avatar',
    activedLoginAgain: 'Sign in only after activation',
  },
  navbar: {
    account: 'Account info',
    refresh: 'Refresh',
    logout: 'Sign out',
    menu: 'Menu',
  },
  label: {
    label: 'Label',
    name: 'Name',
    comment: 'Comment',
    color: 'Color',
    public: 'Public',
    active: 'Active',
    creater: 'Creator',
    createLabel: 'Create Label',
    editLabel: 'Edit Label',
  },
  route: {
    home: 'Home',
    requirement: 'Requirement',
    requirementList: 'Requirement list',
    createRequirement: 'Create requirement',
    updateRequirement: 'Editing requirement',
    solution: 'Quotation',
    solutionList: 'Quotation list',
    createSolution: 'Create quotation',
    updateSolution: 'Editing quotation',
    payment: 'Payment',
    paymentList: 'Payment list',
    createPayment: 'Create payment',
    updatePayment: 'Editing payment',
    config: 'Config',
    quotation: 'Quotation',
    role: 'Role',
    editRole: 'Edit role',
    project: 'Project',
    team: 'Team',
    user: 'User',
    permission: 'Permission',
    module: 'Module',
    moduleList: 'Module list',
    createModule: 'Create module',
    updateModule: 'Edit module',
    createTemplate: 'Create template',
    updateTemplate: 'Edit template',
    todo: 'Todo',
    todoList: 'Todo List',
    createTodo: 'Create Todo',
    account: 'Account Info',
    issue: 'Issue',
    issueList: 'Issue list',
    createIssue: 'Create issue',
    updateIssue: 'Editing issue',
    label: 'Label',
    todoType: 'Todo Type',
    settlementUnit: 'Settlement Unit',
    report: 'Report',
    reportDetail: 'Detail',
    reportSummary: 'Summary',
    notFound: '404',
  },
  form: {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    submit: 'Submit',
    required: 'Required',
    send: 'Send',
    edit: 'Edit',
    delete: 'Delete',
    pass: 'Approve',
    reject: 'Reject',
    create: 'Create',
    approve: 'Approve',
    close: 'Close',
    complete: 'Complete',
    search: 'Search',
    moreSearch: 'More Search',
  },
  operation: {
    loadMore: 'Load more',
    related: 'Related',
    operation: 'Operation',
    confirmMsg: 'Confirm {operation}?',
    goBack: 'Go back',
    view: 'View',
    start: 'Start',
    end: 'End',
    copy: 'Copy',
    agree: 'Agree',
    accept: 'Accept',
  },
  logs: {
    log: 'Logs',
    user: 'User',
    content: 'Content',
    time: 'Time',
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOther: 'Close other',
    closeAll: 'Close all',
  },
  comment: {
    comment: 'Comment',
  },
  requirement: {
    requirement: 'Requirement',
    create: 'Create requirement',
    detail: 'Detail',
    loadMore: 'Load more',
    edit: 'Edit',
    searchKey: 'Requirement title',
    name: 'Name',
    remarks: 'Remarks',
    description: 'Description',
    due: 'Due',
    label: 'Label',
    creater: 'Creator',
    createOn: 'CreateOn',
    urgency: 'Urgency',
    status: 'Status',
    public: 'Public',
    adopt: 'Adopt',
    delete: 'Detele',
    close: 'Close',
    other: 'Other',
    solution: 'Quotation',
    module: 'Module',
    createSolution: 'Create',
    view: 'View',
    manDay: 'Value',
    issue: 'Issue',
    project: 'Project',
  },
  solution: {
    quotaion: 'Quotation',
    searchKey: 'Quotation title',
    createSolution: 'Create quotation',
    unableCreate: 'Missing parameter, unable to create quotation, will return soon',
    unableEdit: 'Missing parameter, unable to edit quotation, will return soon',
    type: 'Type',
    title: 'Title',
    manDay: 'Value',
    creater: 'Creator',
    approval: 'Approval',
    pass: 'Approve',
    reject: 'Reject',
    departmentHead: 'Department Head',
    wait: 'waiting',
    paymentNote: 'Payment Note',
    solution: 'Quotation',
    status: 'Status',
    label: 'Label',
    share: 'Share',
    remarks: 'Remarks',
    totalManDay: 'Total Value',
    baseInfo: 'Base info',
    requirement: 'Requirement',
    specificInfo: 'Specific Info',
    operation: 'Operation',
    addQuotation: 'Add Quotation',
    lackOfQuotation: 'Lack of Quotation',
    startDate: 'Start date',
    endDate: 'Delivery date',
    workDays: 'Work Days',
    effectiveDate: 'Expire Date',
    workDates: 'Demand cycle',
    atLeast: 'At least a quotation',
    typeNotApplicable: 'quotation type not applicable',
  },
  payment: {
    create: 'Create payment',
    payment: 'Payment',
    searchKey: 'Payment title',
    unableCreate: 'Missing parameter, unable to create payment, will return soon',
    unableEdit: 'Missing parameter, unable to edit payment, will return soon',
    label: 'Label',
    projectReturns: 'Project returns',
    returnType: 'Return type',
    superposition: 'Superposition',
    concreteContent: 'Concrete content',
    timeSavingCalculation: 'Time saving calculation',
    usageTimes: 'Usage times',
    saveTime: 'Save time per person',
    affectedDepartments: 'Affected departments',
    actualRevenue: 'Actual revenue',
    remarks: 'remarks',
    specificCalculation: 'Specific calculation',
    manDayReport: 'Value',
    nonWarranty: 'Non warranty',
    warranty: 'Warranty',
    guarantee: 'Warranty',
    requirement: 'Requirement',
    requirementNum: 'Req Num',
    manDaystatus: 'status',
    follower: 'Follower',
    softwareVP: 'Software VP',
    requirementDue: 'Requirement Due',
    requirementDesc: 'Requirement Description',
    requirementName: 'Requirement Name',
    project: 'Project',
    manDay: 'Value',
    warrantyPrice: 'Warranty ManDay/VP',
    noWarrantyPrice: 'Non warranty ManDay/VP',
    addQuotation: 'Add Quotation',
    quotationList: 'Quotation List',
    quotation: 'Quotation',
    title: 'Title',
    creater: 'Creator',
  },
  paymentOptions: {
    nothing: 'Nothing',
    superposition: 'Superposition',
    increaseRevenue: 'Increase company revenue',
    savingManpower: 'Saving manpower',
    costSaving: 'Cost saving',
    notSelected: 'Not selected',
    lessThanOrEqualToTwiceAYear: 'Less than or equal to twice a year',
    lessThanOrEqualTo5TimesAYear: 'Less than or equal to 5 times a year',
    lessThanOrEqualTo10TimesAYear: 'Less than or equal to 10 times a year',
    lessThanOrEqualTo11TimesAYear: 'Less than or equal to 11 times a year',
    AMonthTo1_3Times: '1-3 times a month',
    AWeekTo1_3Times: '1-3 times a week',
    AWeekTo4_5Times: '4-5 times a week',
    ADayTo1_3Times: '1-3 times a day',
    MoreThan3TimesADay: 'More than 3 times a day',
    within1Minute: 'Within one minute',
    minute1_30: '1~30 minutes',
    minute30_60: '30~60 minutes',
    minute60_90: '60~90 minutes',
    minute90_120: '90~120 minutes',
    minute120_150: '120~150 minutes',
    minute150_180: '150~180 minutes',
    moreThan180minute: 'More than 180 minutes',
    department1: '1 department',
    departments2_3: '2-3 departments',
    departments4_6: '4-6 departments',
    departments6_8: '6~8 departments',
    MoreThan8Departments: 'More than 8 departments',
    person1: '1 person',
    person2_5: '2-5 people',
    person6_10: '6-10 people',
    person11_15: '11-15 people',
    person16_25: '16-25 people',
    person26_35: '26-35 people',
    MoreThan35Person: 'More than 35',
  },
  module: {
    module: 'Module',
    searchKey: 'Module name',
    creater: 'Creator',
    unableCreate: 'Missing parameter, unable to create module, will return soon',
    unableEdit: 'Missing parameter, unable to edit module, will return soon',
    label: 'Label',
    requirement: 'Requirment',
    due: 'Due',
    project: 'Project',
    team: 'Team',
    manDay: 'Value',
    isGuarantee: 'Guarantee',
    noGuarantee: 'No Guarantee',
    name: 'Name',
    remark: 'Remark',
    remarkPlaceholder: 'Please fill in the description of the module service pack',
    createModule: 'Create Module',
    editModule: 'Edit Module',
    createTemplate: 'Create Template',
    createTemplateTodo: 'Create Template Todo',
    editTemplate: 'Edit Template',
    taskList: 'Task List',
    settlement: 'Settlement',
    followUp: 'Follow Up',
    grab: 'Grab',
    settled: 'Settled',
    overQuotation: 'Over quotation, unable to settle',
    confirmTips: '{paymentManDay} are available, have selected {todoCount} task, and consume {todoManday} ? (settlement can only be made once)',
    cancelTips: 'Task data must be complete or closed to cancel the module',
    singleCopy: 'Single Copy',
    batchCopy: 'Batch Copy',
    copy: 'Copy',
  },
  todo: {
    createTodo: 'Create Todo',
    unableCreate: 'Missing parameter, unable to create todo',
    project: 'Project',
    title: 'Title',
    type: 'Todo Type',
    module: 'Module',
    owner: 'Owner',
    manDay: 'Value',
    bonus: 'Settlement',
    settlementUnit: 'Unit',
    totalValue: 'Total Value',
    totalValueMsg: 'The total value of the owner cannot exceed the type value',
    ownerMsg: 'At least one owner is required',
    due: 'Due',
    remarks: 'Remarks',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    complete: 'Complete',
    termination: 'Termination',
    delete: 'Revoke',
    check: 'Check',
    checked: 'Checked',
    status: 'Status',
    action: 'Action',
    records: 'Records',
    reviewer: 'Reviewer',
    moduleSettled: 'Module settled',
    batchCreate: 'Batch Create',
    change: 'Change',
    transfer: 'Transfer',
    remarkTips: 'Please fill in the remarks',
    acceptorTips: 'Please select user',
    todoOriginalValue: 'The original value of this todo',
    actualAdjustment: 'According to the actual adjustment',
    transferTodos: 'Transfer todos to',
    forCheck: 'for check',
    grab: 'Grab',
    range: 'Range',
    comment: 'Comment',
    commentTips: 'Please fill in the task description, basic requirements and conditions for receiving',
  },
  quotation: {
    name: 'Name',
    project: 'Applicable Project',
    require: 'Require',
    additional: 'Additional',
    active: 'Active',
  },
  role: {
    name: 'Name',
    comment: 'Description',
    creater: 'Creator',
    permission: 'Permission',
    user: 'User',
    active: 'Active',
    createRole: 'Create Role',
    editRole: 'Modify Role',
    updateUser: 'Update User',
    updatePermission: 'Update Permission',
    unableEdit: 'Missing parameter, unable to modify role, will return soon',
  },
  permission: {
    comment: 'Description',
    groupName: 'Group',
    name: 'Name',
    user: 'User',
    role: 'Role',
    active: 'Active',
    updateUser: 'Update User',
    updateRole: 'Update Role',
  },
  project: {
    project: 'Project',
    name: 'Name',
    description: 'Description',
    createdName: 'Creator',
    active: 'Active',
    team: 'Team',
    manager: 'Manager',
    createProject: 'Create Project',
    editProject: 'Modify Project',
    updateTeam: 'Update Team',
    updateManager: 'Update Manager',
  },
  team: {
    name: 'Name',
    comment: 'Description',
    owner: 'Owner',
    createdName: 'Creator',
    member: 'Member',
    manager: 'Manager',
    createTeam: 'Create Team',
    editTeam: 'Modify Team',
    updateMember: 'Update Member',
    updateManager: 'Update Manager',
    project: 'Project',
    active: 'Active',
  },
  user: {
    name: 'Name',
    permission: 'Personal Permission',
    role: 'Role',
    team: 'Team',
    updateRole: 'Update Role',
    updatePermission: 'Update Personal Permission',
    updateTeam: 'Update Team',
    active: 'Active',
    mobile: 'Mobile',
  },
  todoType: {
    project: 'Project',
    type: 'Type',
    creater: 'Creator',
    active: 'Active',
    firstCategory: 'First Category',
    secondCategory: 'Second Category',
    thirdCategory: 'Third Category',
    value: 'Value',
    category: 'Category',
    templateDownload: 'Template download',
    format: 'Format',
    onlyIntegers: 'Fill in only integers',
    keepTwoDecimalPlaces: 'Keep two decimal places',
  },
  settementUnit: {
    type: 'Type',
    creater: 'Creator',
    active: 'Active',
  },
  issue: {
    issue: 'Issue',
    create: 'Create issue',
    loadMore: 'Load more',
    edit: 'Edit',
    searchKey: 'search key',
    title: 'Title',
    description: 'Description',
    reminder: 'Reminder',
    label: 'Label',
    creater: 'Creator',
    createOn: 'CreateOn',
    urgency: 'Urgency',
    status: 'Status',
    adopt: 'Adopt',
    reject: 'Reject',
    close: 'Close',
    cancel: 'Cancel',
    view: 'View',
  },
  report: {
    title: 'Title',
    module: 'Module',
    creator: 'Creator',
    todoType: 'Todo Type',
    owner: 'Owner',
    due: 'Planned Completion Date',
    status: 'Status',
    manDay: 'Value',
    bonus: 'Settlement',
    notData: 'No data available',
    notExport: 'Unable to export',
    selectInterval: 'Select date range',
    settlementDate: 'Settlement Date',
    sumManDay: 'Total(Value)',
    project: 'Project',
    quotationCategory: 'Quotation Type',
    settlementUnit: 'Settlement Unit',
  },
  remind: {
    checkTodo: 'There are tasks to check',
    settlementModuleByToday: 'There are modules to be settled',
    settlementModuleByWithinThreeDay: 'There are modules to be settled in the next three days',
    haveNewTodo: 'You have a new tasks! Check it out.',
    isCompletedTodo: 'Have you completed your tasks? please go to deal with!',
    haveUnfinishedTodo: 'You have unfinished task, please go to deal with!',
    haveNewGrabTodo: 'You have a new single task released, please go to check',
    grabTodoHasAccepted: 'The order grabbing task you posted has been accepted, please go and handle it',
  },
  template: {
    boundOwner: 'Binding Owner',
    creatingEmptyModule: 'Creating Empty Module',
    creatingModuleFromTemplate: 'Creating Module With Template',
    addTodo: 'Add Todo',
    removeTodo: 'Remove Todo',
    selectTemplate: 'Select template',
    saveTemplate: 'Add as a template',
    totalManDayTips: 'The total value of the currently selected Todo exceeds the value set by the module',
    dueTips: 'Due of Todo not filled in',
    commentTips: 'Remarks not filled in',
    unBoundOwner: 'Todo not bounded Owner',
    moreThanDueTips: 'Due of Todo exceeds the Due of the module',
    projectTips: 'The project of the quotation is inconsistent with the project of the module',
    name: 'Template Name',
    select: 'Select',
    grab: 'Grab',
    todo: 'Todo(Template)',
    grabRange: 'Grab Range',
  },
  grab: {
    isAgreeOwner: 'Whether to allow the user to accept the task',
    refuseTips: 'Please fill in the reason for rejection',
    isAccept: 'Confirm to accept the task',
    contactTips: 'Please enter the remarks',
    contactPlaceholder: 'Note information can be contact information or other contact information',
    canGrabTodos: 'Grab',
    grabList: 'Grab',
    myRelease: 'Released',
    recipientInfo: 'Recipient information',
    refuseReason: 'Refuse to reason',
    empty: 'No data',
  },
};
